module.exports = __webpack_public_path__ + "static/media/3.76492402.png";